module.exports = __webpack_public_path__ + "static/media/Clouds.9b15a0e3.svg";